module.exports = __webpack_public_path__ + "static/img/7bac.4d2e2ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/7bac.jpg
// module id = vDUl
// module chunks = 1